/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSource } from './GetSourceMergePreview200ResponseDataSourceToMergeSource';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSource';

/**
 * 
 * @export
 * @interface GetSourceMergePreview200ResponseDataSourceToMerge
 */
export interface GetSourceMergePreview200ResponseDataSourceToMerge {
    /**
     * 
     * @type {GetSourceMergePreview200ResponseDataSourceToMergeSource}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMerge
     */
    source: GetSourceMergePreview200ResponseDataSourceToMergeSource;
    /**
     * 
     * @type {number}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMerge
     */
    contacts_count: number;
    /**
     * 
     * @type {number}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMerge
     */
    referrals_count: number;
    /**
     * 
     * @type {number}
     * @memberof GetSourceMergePreview200ResponseDataSourceToMerge
     */
    tasks_count: number;
}

/**
 * Check if a given object implements the GetSourceMergePreview200ResponseDataSourceToMerge interface.
 */
export function instanceOfGetSourceMergePreview200ResponseDataSourceToMerge(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "contacts_count" in value;
    isInstance = isInstance && "referrals_count" in value;
    isInstance = isInstance && "tasks_count" in value;

    return isInstance;
}

export function GetSourceMergePreview200ResponseDataSourceToMergeFromJSON(json: any): GetSourceMergePreview200ResponseDataSourceToMerge {
    return GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped(json, false);
}

export function GetSourceMergePreview200ResponseDataSourceToMergeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceMergePreview200ResponseDataSourceToMerge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': GetSourceMergePreview200ResponseDataSourceToMergeSourceFromJSON(json['source']),
        'contacts_count': json['contacts_count'],
        'referrals_count': json['referrals_count'],
        'tasks_count': json['tasks_count'],
    };
}

export function GetSourceMergePreview200ResponseDataSourceToMergeToJSON(value?: GetSourceMergePreview200ResponseDataSourceToMerge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': GetSourceMergePreview200ResponseDataSourceToMergeSourceToJSON(value.source),
        'contacts_count': value.contacts_count,
        'referrals_count': value.referrals_count,
        'tasks_count': value.tasks_count,
    };
}

